var swal = require('bootstrap-sweetalert');
swal.setDefaults({ animation: false });

var router = require('./router').router;
var signin = require('./auth-handler').signin;
var awsConstants = require('./constants').awsConstants;
var authHandler = require('./auth-handler').authHandler;

var username;
var changePasswordFormController = {
    init: function () {
        this.isFirstChange = false;
        if (window.location.hash.indexOf('resetrequired') !== -1) {
            this.isFirstChange = true;
            username = localStorage.getItem('username');
        }
        changePasswordFormView.init();
    },
    validate: function (oldPassword, newPassword, confirmPassword) {
        var errorMessages = [];

        if (newPassword.length < 8) {
            errorMessages.push('New password must be at least 8 characters in length');
        }

        if (!awsConstants.AWSPasswordRegex.test(newPassword)) {
            errorMessages.push('New password must include an uppercase letter, a lower case letter, a number and a special character.');
        }

        if (confirmPassword !== newPassword) {
            errorMessages.push('New password does not match confirmed password.');
        }

        return errorMessages;
    },
    handleSubmit: function (oldPassword, newPassword, confirmPassword) {
        var self = this;
        if (this.processing) return; // Avoid submits when in progress
        changePasswordFormView.toggleSpinnerState('show');
        var errorMessages = this.validate(oldPassword, newPassword, confirmPassword);
        if (errorMessages.length) {
            self.processing = false;
            changePasswordFormView.toggleSpinnerState('hide');
            swal('Change Password Error', errorMessages.join('\n'), 'error');
            return;
        }
        if (this.isFirstChange) {
            // Shared method see app-core.js
            signin(username, oldPassword, newPassword)
                .then(function (result) {
                    router.navigate('/dashboard');
                })
                .catch(function (error) {
                    self.processing = false;
                    changePasswordFormView.toggleSpinnerState('hideÍÎ');
                    swal('Change Password Error', error, 'error');
                });
        } else {
            authHandler.getSession().then(function () {
                window.cognitoUser.changePassword(oldPassword, newPassword, function (error, result) {
                    if (error) {
                        self.processing = false;
                        changePasswordFormView.toggleSpinnerState('hide');
                        swal('Change Password Error', error, 'error');
                        return;
                    }
                    router.navigate('/dashboard');
                });
            });
        }
    }
};

var changePasswordFormView = {
    init: function () {
        this.changePasswordFormEl = document.querySelector('#change-password-form');
        this.changePasswordButtonTextEl = document.querySelector('#change-password-button-text');
        this.changePasswordButtonSpinnerEl = document.querySelector('#change-password-button-spinner');
        this.oldPasswordEl = document.querySelector('#old-password');
        this.newPasswordEl = document.querySelector('#new-password');
        this.confirmPasswordEl = document.querySelector('#confirm-password');
        this.initSubmitHandler();
    },
    toggleSpinnerState: function (state) {
        if (state === 'show') {
            this.changePasswordButtonTextEl.innerHTML = 'Changing password';
            this.changePasswordButtonSpinnerEl.style = 'margin-right:5px;';
        } else {
            this.changePasswordButtonTextEl.innerHTML = 'Sign in';
            this.changePasswordButtonSpinnerEl.style = 'visibility:hidden;';
        }
    },
    initSubmitHandler: function () {
        var self = this;
        this.changePasswordFormEl.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var oldPassword = self.oldPasswordEl.value;
            var newPassword = self.newPasswordEl.value;
            var confirmPassword = self.confirmPasswordEl.value;
            changePasswordFormController.handleSubmit(oldPassword, newPassword, confirmPassword);
        });
    }
};

module.exports = { changePasswordFormController: changePasswordFormController };
